import { SchemaUiConfigType } from '../../schemas/models/schemaDatapointBase';
import { Url } from '../../types';
import {
  configurationMapPayloadSchema,
  configurationMapResponseSchema,
} from './configurationMap.schema';

export type ConfigurationMapField = {
  id: string;
  type: SchemaUiConfigType | 'external';
  dependencies?: string[];
};

export type ConfigurationMapEdge = {
  source: string;
  target: string;
};

export type ConfigurationMapRule = {
  id: string;
  name: string;
  ruleId: number;
  enabled: boolean;
  dependencies: string[];
  error?: string;
};

export type ConfigurationMapHook = {
  id: string;
  name: string;
  hookId: number;
  hookType: 'function' | 'webhook';
  active: boolean;
  dependencies: string[];
  targets: string[];
  error?: string;
};

export type ConfigurationMapResponse = {
  results: {
    fields: ConfigurationMapField[];
    edges: ConfigurationMapEdge[];
    rules: ConfigurationMapRule[];
    hooks: ConfigurationMapHook[];
  };
};

export type ConfigurationMapPayload = {
  queue: Url;
  updatedDatapointIds?: string[];
  actions?: string[];
  hookEvents?: string[];
};

export const configurationMap = (payload: ConfigurationMapPayload) => {
  return {
    endpoint: `/internal/configuration_map`,
    method: 'POST',
    responseSchema: configurationMapResponseSchema,
    payload,
    payloadSchema: configurationMapPayloadSchema,
  } as const;
};
